'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Avatar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Thumbnail = require('../image/Thumbnail');

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

var _Label = require('../typography/Label');

var _Label2 = _interopRequireDefault(_Label);

var _SubLabel = require('../typography/SubLabel');

var _SubLabel2 = _interopRequireDefault(_SubLabel);

require('./avatar.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Core React


function Avatar(props) {
  var imageSrc = props.imageSrc,
      label = props.label,
      subLabel = props.subLabel,
      initials = props.initials;
  var avatarPicture = imageSrc ? _react2.default.createElement(_Thumbnail2.default, {
    imageSrc: imageSrc,
    rounded: true,
    size: 'small'
  }) : _react2.default.createElement(_Label2.default, {
    label: initials
  });
  return _react2.default.createElement('div', {
    className: 'avatar'
  }, avatarPicture, _react2.default.createElement('div', {
    className: 'avatar-text'
  }, _react2.default.createElement(_Label2.default, {
    label: label
  }), _react2.default.createElement(_SubLabel2.default, {
    subLabel: subLabel
  })));
}

Avatar.propTypes = {
  imageSrc: _propTypes2.default.string,
  label: _propTypes2.default.string.isRequired,
  subLabel: _propTypes2.default.string,
  initials: _propTypes2.default.string.isRequired
};
Avatar.defaultProps = {
  imageSrc: '',
  subLabel: ''
};